module.exports = __webpack_public_path__ + "img/circle_purple.fa2174a0.svg";